import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.svg',
    styleUrls: ['./message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageComponent {}
